var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { isFn } from "@al/aku-lc-helpers";
import { useWidget, useAttach, useApp } from "../hooks";
import { FormContext, WidgetContext } from "../context";
import { ReactiveWidget } from "./ReactiveWidget";
export function Widget(props) {
    var app = useApp();
    var parent = useWidget();
    // 如果是 form 的子组件，props.form 内有值，直接使用
    var form = props.form;
    // 如果是 form 本身，创建 form model
    if (props.isForm) {
        form = useAttach(app.createForm(__assign({ basePath: parent === null || parent === void 0 ? void 0 : parent.path }, props), props.force));
    }
    var widget = useAttach(app.createWidget(__assign({ basePath: parent === null || parent === void 0 ? void 0 : parent.path }, props), form, props.force));
    // widget model 内可能有 form model 实例，因此 children 的 props 内会有 form
    var children = isFn(props.children) ? props.children(widget, props.force) : props.children;
    return (React.createElement(FormContext.Provider, { value: form },
        React.createElement(WidgetContext.Provider, { value: widget },
            React.createElement(ReactiveWidget, { widget: widget }, children))));
}
